// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vcPv7","toggle":"styles_toggle__DxPV5","preview":"styles_preview__2UFze"};